import React, { FunctionComponent } from "react";

import { BackgroundAttributeProps, IconProps, IconWithBackgroundAttr } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";

export type IconNameAttributeProps = IconProps & BackgroundAttributeProps & { children: React.ReactElement };

const className = bemClassNames("iconname-attribute");

export const IconNameAttribute: FunctionComponent<IconNameAttributeProps> = ({ children, ...otherProps }) => (
    <div className={className()}>
        <IconWithBackgroundAttr
            {...otherProps}
        />
        {children}
    </div>
);
